import React, { PureComponent, Fragment } from 'react';
// import { Link } from 'react-router-dom';
import { Container, Col, Row } from 'bootstrap-4-react';   

import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperCore, { Autoplay, EffectFade, Navigation } from 'swiper';

// swiper bundle styles
import 'swiper/swiper-bundle.min.css';

// swiper core styles
import 'swiper/swiper.min.css';
 

// import slideImage1 from './../../../assets/img/one-bed-fp.jpg';
// import slideImage2 from './../../../assets/img/two-bed-fp.png';
import axios from 'axios';
import * as apiUrl from '../../../apiUrl';


import { useParams } from "react-router-dom";


function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}
 
SwiperCore.use([Autoplay, EffectFade, Navigation]);
class FloorPlan extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
        formValues: [{ track_id: "", section_description:"", section_property_type: "", slider_image: [], imageURL: "" }],
     
        formValues2: {   section_title: "" },

    };


  }

  componentDidUpdate(prevProps) {

    if ( this.props.params.id !== prevProps.params.id ) {
    const { id } = this.props.params;

    let self = this;

    

    axios.post(apiUrl.apiUrl + '/propertiesinnerpage/edit_propertiesinner_post/' + id)
        .then(res => {



            self.setState({
              
                section_title4: res.data[0].section_title4,
                
             


            });


            


         
         

            


            let formValues = [];

            res.data[0].fourth.forEach((element) => {


                element.imageURL = apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" + element.slider_image;

                formValues.push(element);

                





            });


            
            this.setState({ formValues });



            

        }

        );

      }


  }

  async componentDidMount() {

    let self = this;

    const windowUrl = window.location.href;

    let dataxx = windowUrl.split("properties-inner/");

    axios.post(apiUrl.apiUrl + '/propertiesinnerpage/edit_propertiesinner_post/' + dataxx[1])
        .then(res => {



            self.setState({
              
                section_title4: res.data[0].section_title4,
                
             


            });


            


         
         

            


            let formValues = [];

            res.data[0].fourth.forEach((element) => {


                element.imageURL = apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" + element.slider_image;

                formValues.push(element);

                





            });


            
            this.setState({ formValues });



            

        }

        );




}
    
    render() { 
        return (
          <Fragment>
            <Container fluid className="floorPlanSec"> 
                 
                  <Row>
                    <Col md={12}>
                        <Row>
                            <Col lg={1}></Col>
                            <Col lg={9} className="paddingZero marginLeft">
                              <div className="floorplanhead lightGoldBG "> 
                                <h2 className="canelaMedium secHeading darkBlue">
                                {this.state.formValues2.section_title4}
                                </h2> 
                              </div>
                              <div className="">
                                <Swiper
                                  className="floorPlanSlider"
                                  spaceBetween={50}
                                  slidesPerView={2}
                                  loop={false}
                                  autoplay={false}
                                  effect={'fade'}
                                  navigation={true}
                                >

{

this.state.formValues.map((item) => (
                                  <SwiperSlide  key={'Floor_Plan_'+item.id}> 
                                        <div className="floorPlanDiv">
                                          <Row>
                                            <Col md={6} className="paddingZero">
                                              <div className="floorPlanContent lightGoldBG"> 
                                                <p>
                                                {item.section_description} 
                                                </p> 
                                                  <p className="goldenColor canelaMedium text-uppercase floorText">
                                                   {item.section_property_type}
                                                  </p>  
                                              </div>

                                            </Col>
                                            <Col md={6} className="paddingZero">
                                                <div className="floorImageDiv">
                                                  <img
                                                    src={item.imageURL}
                                                    className="img-fluid"
                                                    alt="slideimage1"
                                                  />
                                                </div>
                                            </Col>
                                          </Row>
                                        </div>
          
                                  </SwiperSlide>

))

}
                       
                                </Swiper>
                              </div>
                            </Col>
                        </Row>
                    
                    </Col>
                  </Row>
                 
            </Container>
          </Fragment>
        );
      }
}


//export default FloorPlan


export default withParams(FloorPlan);